export default __webpack_public_path__ + "static/media/ic-crops-fodder.06be90e4.svg";